import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertTriangle } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-dark-950 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-dark-400 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          Zpět na hlavní stránku
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Podmínky použití</h1>

        <div className="prose prose-invert max-w-none space-y-6 text-dark-300">
          {/* Důrazné upozornění na autorská práva */}
          <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-6 mb-8">
            <div className="flex items-start gap-4">
              <AlertTriangle className="text-red-500 flex-shrink-0 mt-1" size={24} />
              <div>
                <h2 className="text-xl font-bold text-red-400 mb-3">⚠️ AUTORSKÁ PRÁVA</h2>
                <p className="text-red-300 font-medium mb-3">
                  Veškerý obsah aplikace Synapso (testové otázky, texty, obrázky, grafika,
                  databáze otázek a veškeré studijní materiály) je chráněn autorským zákonem
                  a je výhradním vlastnictvím Nakladatelství Olomouc s.r.o.
                </p>
                <p className="text-red-300 font-bold text-lg">
                  JE PŘÍSNĚ ZAKÁZÁNO:
                </p>
                <ul className="text-red-300 font-medium list-disc list-inside mt-2 space-y-1">
                  <li>Kopírování a rozšiřování obsahu</li>
                  <li>Pořizování screenshotů otázek a odpovědí</li>
                  <li>Sdílení obsahu s třetími osobami</li>
                  <li>Stahování nebo extrahování dat z aplikace</li>
                  <li>Jakékoliv komerční využití obsahu</li>
                </ul>
                <p className="text-red-300 font-medium mt-3">
                  V případě porušení autorských práv bude účet okamžitě zablokován
                  bez nároku na vrácení peněz.
                </p>
              </div>
            </div>
          </div>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Provozovatel</h2>
            <p>
              Nakladatelství Olomouc s.r.o.<br />
              Vítězství 229/7, 779 00 Olomouc<br />
              IČO: 64612023<br />
              Zapsáno v OR u Krajského soudu v Ostravě, oddíl C, vložka 8911
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Použití aplikace</h2>
            <p>
              Používáním aplikace Synapso souhlasíte s těmito podmínkami. Aplikace slouží
              jako doplňkový studijní nástroj pro přípravu na přijímací zkoušky na lékařské
              fakulty. Provozovatel nezaručuje úspěšné složení přijímacích zkoušek.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Platby</h2>
            <p>
              Přístup k obsahu je podmíněn zakoupením předplatného. Zakoupené předplatné
              je nevratné. Aktuální ceník je dostupný na stránce{' '}
              <Link to="/pricing" className="text-primary-400 hover:text-primary-300">
                Ceník
              </Link>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Kontakt</h2>
            <p>
              <a href="mailto:info@synapso.cz" className="text-primary-400 hover:text-primary-300">
                info@synapso.cz
              </a>
            </p>
          </section>

          <p className="text-dark-500 text-sm mt-8">
            Platné od 1. ledna 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
